import {
  generic_get_network_request,
  generic_post_network_request,
} from '../axiosClient/axiosClient';
import {
  LegacyLogin_API_Payload_Data_Type,
  LegacyLogin_API_Response_Type,
  Login_API_Payload_Data_Type,
  Login_API_Response_Type,
  Logout_API_Response_Type,
  Partner_Company_Type,
} from '../types/auth';

export interface GetPartnerCompanies_Response_Type {
  data: Partner_Company_Type[];
}

export const getPartnerCompanies = () =>
  generic_get_network_request<GetPartnerCompanies_Response_Type>('user/partner-companies');

export const legacyLogin = (
  api_endpoint: string,
  api_payload: LegacyLogin_API_Payload_Data_Type
) => {
  return generic_post_network_request<
    LegacyLogin_API_Response_Type,
    LegacyLogin_API_Payload_Data_Type
  >(api_endpoint, api_payload);
};

export const login = (
  api_endpoint: string,
  api_payload: Login_API_Payload_Data_Type
) => {
  return generic_post_network_request<
    Login_API_Response_Type,
    Login_API_Payload_Data_Type
  >(api_endpoint, api_payload);
};

export const logout = (api_endpoint: string) => {
  return generic_get_network_request<Logout_API_Response_Type>(api_endpoint);
};